<template>
  <span class="container-circle" :style="styles">*</span>
</template>

<script>
export default {
	props: {
		styles: {
			type: Object,
			default: () => ({
				color: 'red',
				fontSize: '10px',
				marginLeft: '1px'
			})
		}
	}
};
</script>

<style>

</style>
